import {Form, Input} from 'antd';
import cn from 'classnames';
import React from 'react';

import './setting-tamplate-target-table-query.less';
import {EWatcherFieldFlag} from 'components/report-configuration/hooks/use-form-fields-manager';
import {isEmptyArray} from 'shared/utils';
import {useAppSelector} from 'store/config/hooks';
import {selectDocumentUploadTemplateData} from 'store/slices/document-upload-template/document-upload-template-selectors';

import {ESettingTemplateTargetFormQueryFields} from '../../constants';

interface ISettingTemplateTargetTableQueryProps{
    checkArrayIndependentWatcherFlag: (fieldKey: string, flag: EWatcherFieldFlag) => boolean;

}

export const SettingTemplateTargetTableQuery = (
    {
        checkArrayIndependentWatcherFlag,
    }: ISettingTemplateTargetTableQueryProps,
) => {
    const documentUploadTemplate = useAppSelector(selectDocumentUploadTemplateData);

    const getInitialValue = (name: string) => {
        const {dffSegmentValues} = documentUploadTemplate ?? {};

        if (dffSegmentValues) {
            const defaultValues = Object
                .entries(dffSegmentValues)
                .map(value => ({
                    name: value[1].segmentColumnName,
                    value: value[1].segmentValue,
                }));

            if (!isEmptyArray(defaultValues)) return defaultValues.filter(value => value.name === name)[0]?.value || '';
        }
        return null;
    };

    return (
        <div className={cn('setting-template-target-query__body')}>
            <Form.Item
                name={ESettingTemplateTargetFormQueryFields.attribute3}
                style={{width: 220}}
                label="Загружать с номера строки"
                rules={[{required: true}]}
                initialValue={getInitialValue(ESettingTemplateTargetFormQueryFields.attribute3)}
            >
                <Input
                    disabled={checkArrayIndependentWatcherFlag(
                        ESettingTemplateTargetFormQueryFields.attribute3,
                        EWatcherFieldFlag.isDisabled,
                    )}
                    autoComplete="off"
                    placeholder="Введите номер строки"
                />
            </Form.Item>
            <Form.Item
                name={ESettingTemplateTargetFormQueryFields?.attribute4}
                style={{width: 220}}
                label="Формат даты"
                rules={[{required: true}]}
                initialValue={getInitialValue(ESettingTemplateTargetFormQueryFields.attribute4)}
            >
                <Input
                    disabled={checkArrayIndependentWatcherFlag(
                        ESettingTemplateTargetFormQueryFields.attribute4,
                        EWatcherFieldFlag.isDisabled,
                    )}
                    autoComplete="off"
                    placeholder="Введите формат даты"
                />
            </Form.Item>
        </div>
    );
};
